import * as React from 'react';
import { connect } from 'react-redux';

import StatisticsSidePanel from 'components/statistics-side-panel/StatisticsSidePanel';

import { abbrNum } from 'utils/helper/common';
import { __t, applyTranslations } from 'utils/language';
import { PARTICIPANT_TYPE_TO_STATE_MAP } from 'utils/campaignParticipants';
import { renderPrice } from 'utils/helper/price';
import { getFormattedPercentageRate } from 'utils/formatters';
import { insertIf } from 'utils/list';

import type { CampaignStatistics } from 'types';

applyTranslations(require('./state-statistics-side-panel.i18n.json'));

type OwnProps = {
  channel: string,
  participantsType: string,
  isLoadingStatistics: boolean
};

type StateProps = {
  statistics: CampaignStatistics
};

type Props = {
  // eslint-disable-next-line react/no-unused-prop-types
  dispatch: any // added by redux connect
} & OwnProps & StateProps;

const StateStatisticsSidePanel = (
  {
    participantsType,
    channel,
    statistics,
    isLoadingStatistics
  }: Props
): JSX.Element => {
  const currentState = PARTICIPANT_TYPE_TO_STATE_MAP[participantsType];

  return (
    <StatisticsSidePanel
      title={__t(`state_statistics_side_panel.title.${currentState.state}`)}
      isLoadingStatistics={isLoadingStatistics}
      items={[
        {
          label: __t('state_statistics_side_panel.creators_label'),
          value: String(statistics.numCreators)
        },
        {
          label: __t('state_statistics_side_panel.followers_label'),
          value: abbrNum(statistics.totalFollowers)
        },
        {
          label: __t('state_statistics_side_panel.engagement_rate_label'),
          value: getFormattedPercentageRate(statistics.engagementRate),
          tooltip: __t('state_statistics_side_panel.engagement_rate_tooltip')
        },
        ...insertIf(channel === 'instagram', {
          label: __t('state_statistics_side_panel.creator_cpm_label'),
          value: renderPrice(statistics.cpm, { separateThousands: false }),
          tooltip: __t('state_statistics_side_panel.creator_cpm_tooltip')
        }),
        ...insertIf(channel === 'instagram', {
          label: __t('state_statistics_side_panel.creator_cpe_label'),
          value: renderPrice(statistics.cpe, { separateThousands: false }),
          tooltip: __t('state_statistics_side_panel.creator_cpe_tooltip')
        })
      ]}
    />
  );
};

const mapStateToProps = ({ campaignDashboardStatistics }): StateProps => ({
  // fetched by top-level component
  statistics: campaignDashboardStatistics.statistics.creator
});

export default connect(mapStateToProps)(StateStatisticsSidePanel);
